import React from "react";

import { Avatar } from "@mui/material";
import { makeStyles } from "tss-react/mui";

import { colors } from "@/theme/overrides/colors";

import FruitsIcon from "../Icons/FruitsIcon";
import PlateCoverIcon from "../Icons/PlateCoverIcon";

interface Props {
  category: string;
  background?: boolean;
}

const useStyles = makeStyles()({
  foodIcon: {
    color: colors.primary,
    backgroundColor: "rgba(31,212,175,0.1)", // #1FD4AF, 10% opacity
  },
  fruitIcon: {
    color: colors.secondary,
    backgroundColor: "rgba(255,157,55,0.1)", // #FF9D37, 10% opacity
  },
  noBackground: {
    backgroundColor: "transparent",
  },
});

const FoodItemIcon: React.FC<Props> = ({ category, background = true }) => {
  const { classes, cx } = useStyles();
  switch (category) {
    case "Fresh Fruits":
      return (
        <Avatar
          className={cx(classes.fruitIcon, {
            [classes.noBackground]: !background,
          })}
        >
          <FruitsIcon htmlColor={colors.grey} />
        </Avatar>
      );
    default:
      return (
        <Avatar
          className={cx(classes.foodIcon, {
            [classes.noBackground]: !background,
          })}
        >
          <PlateCoverIcon htmlColor={colors.grey} />
        </Avatar>
      );
  }
};

export default FoodItemIcon;
